export default __webpack_public_path__ + "static/media/fifth-ss.c89c8071.png";